import { ref } from 'vue';
import { MediaModel } from '../models/media.model';

export const useMediaGallery = () => {
  const isVisibleMediaGallery = ref(false);
  const selectedMediaId = ref<number | null>(null);

  const openMediaGallery = (media: MediaModel): void => {
    isVisibleMediaGallery.value = true;
    selectedMediaId.value = (media?.id as number) ?? null;
  };

  const closeMediaGallery = (): void => {
    isVisibleMediaGallery.value = false;
    selectedMediaId.value = null;
  };

  return {
    isVisibleMediaGallery,
    selectedMediaId,
    openMediaGallery,
    closeMediaGallery,
  };
};
